import React, { useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {Grid,Card,List,ListItem,ListItemIcon} from "@mui/material"
import { CardMedia } from '@mui/material';
import FAQ from "./FAQ";
import { useMediaQuery } from '@mui/material';
import { useTranslation } from "react-i18next";
const Products = () => {
  const { t } = useTranslation();


    // Mobil cihazlar için medya sorgusu
    const isMobile = useMediaQuery('(max-width:600px)');
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

 const getProducts = () => [
  {
    id: 1, 
    name: t("product.product_1.name"),
    description:t("product.product_1.description"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/netapro1.png",
    additionalImage: "https://www.remora.com.tr/wp-content/uploads/2024/05/Goruntu-16.04.2024-11.08-scaled-e1715327213932.jpeg",
    
    images: [
      "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1775-scaled.jpeg",
      "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1743-scaled.jpeg",
      "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1817-scaled.jpeg",
      "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1741-scaled.jpeg"
    ],
    details: t("product.product_1.details"),
    specifications: {
      girişGüçKaynağı: "220 V AC 50/60 Hz",
      çıkışGüçKaynağı: "24 V DC",
      güçTüketimi: "740W",
      hariciGüçKutusuBoyutları: "41cm x 34cm x 21cm",
      temizlemeKapasitesi: "7 m²/dk",
      kabloUzunluğu: "30 m",
      fırçaDeğiştirilebilir:  t("product.yes"),
    },
    technicalInfo: {
      ağırlık: "9,5 kg",
      robotölçüleri: "42cm x 42cm x 22cm",
      filtreHacmi: "42 cm³",
    },
  },
  {
    id: 2,
    name: t("product.product_2.name"),
    description: t("product.product_2.description"),
    image: "https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-70.png",
    videoUrl: "https://www.remora.com.tr/wp-content/uploads/2025/05/Ultrasonic-Video.mp4",
    additionalImage:"https://www.remora.com.tr/wp-content/uploads/2025/03/1.jpg",
    Image2: "https://www.remora.com.tr/wp-content/uploads/2025/05/Ekran-goruntusu_21-3-2025_162544_drive.google.com_.jpeg",
    
    
    images: [
      "https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-57.png",
      "https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-70.png",
      "https://www.remora.com.tr/wp-content/uploads/2025/05/Konu-56-Photoroom.png-Photoroom-removebg-preview.png",
      "https://www.remora.com.tr/wp-content/uploads/2025/05/6-removebg-preview.png",
      "https://www.remora.com.tr/wp-content/uploads/2025/05/3.jpg",
    ],
    
    details: t("product.product_2.details"),
   
  },
  {
    id: 3,
    name: t("product.product_3.name"),
    description: t("product.product_3.description"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/netapros2.png",
    videoUrl: "https://www.youtube.com/watch?v=jDPzI9HORjY",
    additionalImage: "https://www.remora.com.tr/wp-content/uploads/2024/05/Goruntu-16.04.2024-11.08-scaled-e1715327213932.jpeg",
    images: [
      "https://www.remora.com.tr/wp-content/uploads/2025/05/background.jpg",
      "https://www.remora.com.tr/wp-content/uploads/2025/05/netapros.jpg"
    ],
    details: t("product.product_3.details"),
    specifications: {
      girişGüçKaynağı: "220 V AC 50/60 Hz",
      çıkışGüçKaynağı: "24 V DC",
      güçTüketimi: "740W",
      hariciGüçKutusuBoyutları: "41cm x 34cm x 21cm",
      temizlemeKapasitesi: "7 m²/dk",
      kabloUzunluğu: "30 m",
      fırçaDeğiştirilebilir: "Evet",
    },
    technicalInfo: {
      ağırlık: "9,5 kg",
      robotölçüleri: "42cm x 42cm x 22cm",
      filtreHacmi: "42 cm³",
    },
  },
  
  
];

const products = getProducts();

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + products.length) % products.length);
  };

  const handleMoreInfo = () => {
    // Navigate to the ProductDetail page with the current product's id
    navigate(`/urunler/${products[currentIndex].id}`);
  };
  
  return (
    <>
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(to right, rgb(73, 155, 222), #2a5298)",
          position: "relative",
          overflow: "hidden",
          padding: { xs: "5px", sm: "5px" },
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={products[currentIndex].id}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",  // Mobilde dikey, webde yatay düzen
              alignItems: "center",
              gap: "20px",
              color: "white",
              textAlign: "center",
              width: "100%",
               maxWidth: isMobile ? "90vw" : "1200px", // büyük ekranlar için max 1200px
        padding: "0 20px",  // yandan biraz boşluk ver
            }}
          >
            <motion.img
              src={products[currentIndex].image}
              alt={products[currentIndex].name}
              style={{
                width: isMobile ? "90%" : "50%",  // Webde resim daha küçük, mobilde %90
                maxWidth: isMobile ? "450px" : "550px",  // Mobilde 300px, webde 450px
                height: "auto",
                borderRadius: "20px",
                objectFit: "contain",
                marginBottom: isMobile ? "10px" : "0",  // Mobilde boşluk, webde olmasın
              }}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
            />
  
            <Box sx={{ textAlign: "center", width: "100%", maxWidth: "600px", mt: 0 }}>
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
               <Typography
  variant="h1"
  fontWeight="bold"
  sx={{
    fontSize: {
      xs: '2.5rem',
      sm: '3.5rem',
      md: '4.5rem',
      lg: '5.5rem',
      xl: '6rem',
    }
  }}
>
  {t(products[currentIndex].name)}
</Typography>
              </motion.div>
  
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Typography variant="h1" fontWeight="bold"  sx={{
              fontSize: {
                xs: '1rem',
                sm: '1.3rem',
                md: '1.6rem',
                lg: '1.8rem',
                xl: '2rem',
              },
              mt: 1,
            }}>
                {t(products[currentIndex].description)}
                </Typography>
              </motion.div>
  
              <Button
                variant="contained"
                sx={{
                  mt: 3,
                 fontSize: {
              xs: "0.8rem",
              sm: "0.9rem",
              md: "1rem",
              lg: "1.1rem",
            },
            padding: {
              xs: "12px 20px",
              sm: "16px 28px",
              md: "20px 32px",
              lg: "24px 36px",
            },
            backgroundColor: "#FF9800",
            color: "white",
            "&:hover": {
              backgroundColor: "#F57C00",
            },
          }}
          onClick={handleMoreInfo}
        >
          {t('product.button')} 
        </Button>
      </Box>
    </motion.div>
  </AnimatePresence>

  
        {/* Ok simgelerinin eski yerlerine alınması */}
      <ArrowBackIos
    onClick={handlePrev}
    sx={{
      position: "absolute",
      left: 20,
      cursor: "pointer",
      color: "white",
      fontSize: "35px",
    }}
  />
  <ArrowForwardIos
    onClick={handleNext}
    sx={{
      position: "absolute",
      right: 20,
      cursor: "pointer",
      color: "white",
      fontSize: "35px",
    }}
  />
</Box>
    
  

    
  

      {/* Ürün Özellikleri */}
      <Box sx={{ p: 5, width: "100%", backgroundColor: "#f0f4f8" }}>
  <Grid container spacing={4}>
    {/* Neta Pro Özellikleri */}
   <Grid item xs={12} sm={6} md={4}> {/* Mobilde 12 kolon, küçük ekranlarda 6 kolon, büyük ekranlarda 4 kolon */}
      <Card sx={{
  p: 4,
  backgroundColor: "white",
  boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
  borderRadius: "20px",
  transition: "transform 0.3s ease-in-out",
  height: "600px", // Kartı daha uzun yaptık
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  // overflow: "auto", // <-- Bunu kaldırın!
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
  }
}}>
        {/* Görsel Ekleme */}
        <CardMedia
          component="img"
          alt="Neta Pro"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/PNG_NETA.png"
         sx={{
    objectFit: 'contain',
    borderRadius: '10px',
    width: "100%",
    height: "200px", // Görseli büyük tutun
    mb: 2
  }}
        />
        <Typography variant="h4" color="orange" fontWeight="bold" mb={2} textAlign="center">
          NETA PRO
        </Typography>
        <List sx={{ pl: 2 }}>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <ListItemIcon>
              <img 
                src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
                alt="Ninja Weapon" 
                width="20" 
                height="20"
                style={{ objectFit: "contain" }} 
              />
            </ListItemIcon>
            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.1')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <ListItemIcon>
              <img 
                src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
                alt="Ninja Weapon" 
                width="20" 
                height="20"
                style={{ objectFit: "contain" }} 
              />
            </ListItemIcon>
            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.2')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <ListItemIcon>
              <img 
                src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
                alt="Ninja Weapon" 
                width="20" 
                height="20"
                style={{ objectFit: "contain" }} 
              />
            </ListItemIcon>
            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.3')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <ListItemIcon>
              <img 
                src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
                alt="Ninja Weapon" 
                width="20" 
                height="20"
                style={{ objectFit: "contain" }} 
              />
            </ListItemIcon>
            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.4')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <ListItemIcon>
              <img 
                src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
                alt="Ninja Weapon" 
                width="20" 
                height="20"
                style={{ objectFit: "contain" }} 
              />
            </ListItemIcon>
            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.5')} 
            </Typography>
          </ListItem>
        </List>

        {/* Ürün Sayfasına Git Butonu */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            sx={{
              borderRadius: "10px",
              padding: "10px 20px",
              textTransform: "none",
              backgroundColor: "orange",  
              color: "white",  
              '&:hover': {
                backgroundColor: "#ff8c00",  
              },
            }}
            onClick={() => navigate("/urunler/1")}  // Ürünün detay sayfasına yönlendirme
          >
          {t('product.feature_netapro.button')} 
          </Button>
        </Box>
      </Card>
    </Grid>
  

      {/* Neta Pro S Özellikleri */}
    <Grid item xs={12} sm={6} md={4}> {/* Mobilde 12 kolon, küçük ekranlarda 6 kolon, büyük ekranlarda 4 kolon */}
    <Card sx={{
  p: 4,
  backgroundColor: "white",
  boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
  borderRadius: "20px",
  transition: "transform 0.3s ease-in-out",
  height: "600px", // Kartı daha uzun yaptık
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  // overflow: "auto", // <-- Bunu kaldırın!
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
  }
}}>
        {/* Görsel Ekleme */}
        <CardMedia
          component="img"
          alt="Neta Pro S"
          image="https://www.remora.com.tr/wp-content/uploads/2025/05/netapros2.png"
         sx={{
    objectFit: 'contain',
    borderRadius: '10px',
    width: "100%",
    height: "200px", // Görseli büyük tutun
    mb: 2
  }}
        />
        <Typography variant="h4" color="orange" fontWeight="bold" mb={2} textAlign="center">
          NETA PRO S
        </Typography>
        <List sx={{ pl: 2 }}>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>

            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
             {t('product.feature_netapro.1')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.2')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.3')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>

            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.4')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netapro.5')}  </Typography>
          </ListItem>
        </List>
            {/* Ürün Sayfasına Git Butonu */}
    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
      <Button
         variant="contained"
         sx={{
           borderRadius: "10px",
           padding: "10px 20px",
           textTransform: "none",
           backgroundColor: "orange",  // Turuncu rengini buraya ekledik
           color: "white",  // Yazı rengini beyaz yapıyoruz
           '&:hover': {
             backgroundColor: "#ff8c00",  // Hover durumunda biraz daha açık turuncu renk
           },
         }}
         onClick={() => navigate("/urunler/3")}  // Ürünün detay sayfasına yönlendirme
      >
       {t('product.feature_netapro.button')} 
      </Button>
    </Box>
      </Card>
    </Grid>

    {/* Neta Sonic Özellikleri */}
  <Grid item xs={12} sm={6} md={4}> {/* Mobilde 12 kolon, küçük ekranlarda 6 kolon, büyük ekranlarda 4 kolon */}
    <Card sx={{
  p: 4,
  backgroundColor: "white",
  boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
  borderRadius: "20px",
  transition: "transform 0.3s ease-in-out",
  height: "600px", // Kartı daha uzun yaptık
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  // overflow: "auto", // <-- Bunu kaldırın!
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
  }
}}>
        {/* Görsel Ekleme */}
        <CardMedia
          component="img"
          alt="Neta Sonic"
          height="200"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-70.png"
          sx={{
    objectFit: 'contain',
    borderRadius: '5px',
    width: "100%",
    height: "200px", // Görseli büyük tutun
    mb: 2
  }}
        />
        <Typography variant="h4" color="orange" fontWeight="bold" mb={2} textAlign="center">
          NETA SONİC
        </Typography>
        <List sx={{ pl: 2 }}>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netasonic.1')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netasonic.2')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netasonic.3')} 
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
          <ListItemIcon>
          <img 
         src="https://www.remora.com.tr/wp-content/uploads/2025/05/pngwing.com-1.png" 
        alt="Ninja Weapon" 
        width="20" 
        height="20"
        style={{ objectFit: "contain" }} // Görüntüyü düzgün sığdırır
      />
</ListItemIcon>



            


            <Typography variant="body1" sx={{ color: "#34495E", fontSize: "16px", fontWeight: "500" }}>
            {t('product.feature_netasonic.4')} 
            </Typography>
          </ListItem><ListItem sx={{ display: "flex", alignItems: "center" }}>
          



           
          </ListItem>
        </List>
            {/* Ürün Sayfasına Git Butonu */}
    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
      <Button
        variant="contained"
        sx={{
          borderRadius: "10px",
          padding: "10px 20px",
          textTransform: "none",
          backgroundColor: "orange",  // Turuncu rengini buraya ekledik
          color: "white",  // Yazı rengini beyaz yapıyoruz
          '&:hover': {
            backgroundColor: "#ff8c00",  // Hover durumunda biraz daha açık turuncu renk
          },
        }}
        onClick={() => navigate("/urunler/2")}  // Ürünün detay sayfasına yönlendirme
      >
       {t('product.feature_netasonic.button')} 
      </Button>
    </Box>
      </Card> 
    </Grid>
  </Grid>
</Box>
{/* Ekipmanlar */}
<Box 
  id="equipment"  // Bu id'yi ekledik

sx={{ p: 5, width: "100%", backgroundColor: "#f0f4f8", mt: 5,position: "relative" }}>
  <Typography variant="h4" color="primary" fontWeight="bold" mb={3} textAlign="center">
    EKİPMANLAR
  </Typography>

  <Grid container spacing={4}>
    {/* Ekipman 1 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
  
      >
        
        <CardMedia
          component="img"
          alt="Ekipman 1"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9421-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.1')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>
      </Card>
    </Grid>

    

    {/* Ekipman 3 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
    
      
      >
        
        <CardMedia
          component="img"
          alt="Ekipman 3"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1731-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.2')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text2')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>

    {/* Ekipman 4 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      
      >
        
        <CardMedia
          component="img"
          alt="Ekipman 4"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2025/05/88.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.3')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text3')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>
     {/* Ekipman 5 */}
     <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
     
      >
       
        <CardMedia
          component="img"
          alt="Ekipman 5"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9471-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.4')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text4')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>
     {/* Ekipman 6 */}
     <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      
      >
        
        <CardMedia
          component="img"
          alt="Ekipman 6"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9733-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.5')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text5')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>
     {/* Ekipman 7 */}
     <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      
      >
        
        <CardMedia
          component="img"
          alt="Ekipman 7"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9412-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.6')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text6')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>
     
    {/* Ekipman 9 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      
      >
        <CardMedia
          component="img"
          alt="Ekipman 9"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2025/05/IMG_1761-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.7')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text7')} 
            </Typography>
             {/* Buton kısmı */}
             <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

  </Card>
</Grid>
  {/* Ekipman 10 */}
  <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
     
      >
        <CardMedia
          component="img"
          alt="Ekipman 10"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/2-kopyasi-1.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.8')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text8')} 
            </Typography>
             {/* Buton kısmı */}
             <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

  </Card>
</Grid>
{/* Ekipman 2 */}
<Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      >
        
        <CardMedia
          component="img"
          alt="Ekipman 2"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9632-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.9')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text9')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>
      
  
    
    {/* Ekipman 11 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      
      >
        <CardMedia
          component="img"
          alt="Ekipman 11"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9423-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.10')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text10')} 
            </Typography>
        {/* Buton kısmı */}
        <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>


  </Card>
</Grid>
{/* Ekipman 8 */}
<Grid item xs={12} sm={6} md={3}>
      <Card sx={{
        p: 3,
        backgroundColor: "white",
        boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
        }
      }}
      
      >
    
        <CardMedia
          component="img"
          alt="Ekipman 8"
          height="260"
          image="https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9419-Photoroom.png-Photoroom.png" // Ekipmanın görselini buraya ekleyin
          sx={{
            objectFit: 'cover',
            borderRadius: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" mt={2}>
        {t('Equipments.11')} 
        </Typography>
        <Typography variant="body2" color="textSecondary" textAlign="center" mt={1}>
        {t('Equipments.text11')} 
            </Typography>
            <Button
  variant="contained"
  sx={{
    alignSelf: "center", 
    marginTop: "auto", 
    borderRadius: "15px", 
    padding: "6px 12px", 
    fontSize: "0.875rem", 
    minWidth: "120px", 
    backgroundColor: "#FF9800", // Turuncu renk
    "&:hover": {
      backgroundColor: "#F57C00", // Hover rengi (daha koyu turuncu)
    },
  }}
  onClick={() => navigate("/iletisim")}
>
{t('Equipments.button')} 
</Button>

      </Card>
    </Grid>

    <Grid>
   
    </Grid>
    </Grid>
    

  {/* Sağ Alt Köşedeki Buton */}
  
</Box>


      {/* Sıkça Sorulan Sorular */}
      <Box sx={{ p: 4, width: "100%" }}>
        <FAQ />
      </Box>
    </>
  );

};

export default Products;
